import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core'
import { EpicWithStatus } from '@modules/private/worklog/data/interfaces/epic.interface'
import { EpicCategory, EPIC_CATEGORIES, EPIC_STATUS_META, EPIC_STATUS_ORDER } from '../../data/constants/roadmap.constants'

interface CategoryGroup {
  category: EpicCategory
  epics: EpicWithStatus[]
  achieved: number
  total: number
  progress: number
}

/**
 * Vision board de ÉPICAS para dirección. Agrupa por categoría (Módulos · IA · Engagement ·
 * Mobile · Operación) y muestra el avance real de cada una.
 *
 * Lo que cambió con la fusión (ADR-0040 · D13): el estado ya no se declara, lo deriva el backend
 * de las tareas. Una épica pasa de propuesta a conseguida sola, conforme se cierra su trabajo —
 * antes había que acordarse de editar el JSON, y la tarjeta mentía hasta que alguien lo hacía.
 */
@Component({
  selector: 'app-roadmap-epics',
  templateUrl: './roadmap-epics.component.html',
  styleUrls: ['./roadmap-epics.component.scss']
})
export class RoadmapEpicsComponent implements OnChanges {
  @Input() epics: EpicWithStatus[] | null = null
  @Output() select = new EventEmitter<EpicWithStatus>()

  groups: CategoryGroup[] = []

  readonly EPIC_STATUS_META = EPIC_STATUS_META

  ngOnChanges(): void {
    this.build()
  }

  private build(): void {
    const all = this.epics ?? []

    this.groups = EPIC_CATEGORIES.map((category) => {
      const es = all
        .filter((e) => e.epic.category === category.id)
        .sort((a, b) => EPIC_STATUS_ORDER.indexOf(a.status) - EPIC_STATUS_ORDER.indexOf(b.status) || a.epic.order - b.epic.order)
      const achieved = es.filter((e) => e.status === 'achieved').length
      return { category, epics: es, achieved, total: es.length, progress: es.length ? Math.round((achieved / es.length) * 100) : 0 }
    }).filter((grp) => grp.total > 0)
  }

  onEpic(e: EpicWithStatus): void {
    this.select.emit(e)
  }

  /** Avance de la épica en su propio trabajo. Sin tareas no hay barra que pintar. */
  progressOf(e: EpicWithStatus): number {
    return e.taskCount ? Math.round((e.doneCount / e.taskCount) * 100) : 0
  }

  epicDate(e: EpicWithStatus): string {
    return e.epic.date ?? 'Sin fecha'
  }
}
